import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDocument3Line = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M18 2C19.1046 2 20 2.89543 20 4V15.5858C20 16.1162 19.7893 16.6249 19.4142 17L15 21.4142C14.6249 21.7893 14.1162 22 13.5858 22H6C4.89543 22 4 21.1046 4 20V4C4 2.89543 4.89543 2 6 2H18ZM18 4H6V20H12V15.5C12 14.6716 12.6716 14 13.5 14H18V4ZM17.5858 16H14V19.5858L17.5858 16ZM10 11C10.5523 11 11 11.4477 11 12C11 12.5523 10.5523 13 10 13H9C8.44772 13 8 12.5523 8 12C8 11.4477 8.44772 11 9 11H10ZM15 7C15.5523 7 16 7.44771 16 8C16 8.55229 15.5523 9 15 9H9C8.44772 9 8 8.55229 8 8C8 7.44771 8.44772 7 9 7H15Z" })
});
export default SvgDocument3Line;
